import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import {
  Autocomplete,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import supportedFunctions from '../../utils/supportedFunctions.json';
import { useRef } from 'react';
import { getVariables, parseSentence } from '../../utils/helpers';

const EditChecker = () => {
  const inputRef = useRef();
  const dispatch = useDispatch();
  const { condition_id, sub_condition_id, checker_id } = useParams();

  const { condition } = useSelector((state) => state.general);

  const [sentence, setSentence] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'condition',
        route: `conditions/getConditionById`,
        conditionId: condition_id,
      })
    );
  }, []);
  if (condition?._id !== condition_id) {
    dispatch(
      generalSet({
        reduxField: 'condition',
        value: null,
      })
    );
  }
  if (!condition?._id || !Array.isArray(condition?.subConditions) || !condition?.subConditions.length) {
    return <Spinner />;
  }
  const subCondition = condition.subConditions.filter((sCon) => sCon._id === sub_condition_id)[0];
  console.log({ subCondition, condition });
  if (!subCondition?._id) {
    return (
      <div>
        <h4>No Condition Found</h4>
      </div>
    );
  }

  const checker = subCondition.checkers?.filter((ckr) => ckr._id === checker_id)[0];
  if (!checker?._id) {
    return (
      <div>
        <h4>No Checker Found</h4>
      </div>
    );
  }

  const filteredFunctions = supportedFunctions.filter((func) => {
    const fullText = func.name + func.description + func.syntax;
    return fullText.toLowerCase().includes(searchTerm.toLowerCase());
  });

  return (
    <div data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center pt-4 pt-lg-0'>
        <div className='col-lg-12 d-flex justify-content-center mt-4 pt-lg-0 border-bottom'>
          <h1>Edit Checker</h1>
        </div>
        <div className='col-lg-12 d-flex justify-content-center mt-2 pt-lg-0'>
          <span>
            <h5>{checker.name}</h5>
          </span>
        </div>
        <div className='col-lg-12 d-flex justify-content-center mt-2 pt-lg-0 border-bottom'>
          <Link to={`/condition/${condition._id}`}>
            <h6>{condition.name}</h6>
          </Link>{' '}
          <span className='ml-2 mr-2'>
            <h6> | </h6>
          </span>
          <Link to={`/subcondition/${condition._id}/${subCondition._id}`}>
            <h6>{subCondition.name}</h6>
          </Link>
        </div>
      </div>
      {(() => {
        const options = getVariables(condition, subCondition);
        return (
          <>
            <div className='container'>
              <div className='row d-flex justify-content-center mt-4 pt-lg-0 flex-wrap'>
                {options.map((op) => (
                  <Fragment key={op.id}>
                    <div
                      className='col-md-4 border p-2 pointer'
                      onClick={() => {
                        inputRef.current.value = `${inputRef.current.value} {{${op.id}}}`;
                        setSentence(inputRef.current.value);
                      }}
                    >{`${op.varType} - ${op.name} - ${op.id}`}</div>
                  </Fragment>
                ))}
              </div>
            </div>
          </>
        );
      })()}
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <div className='col-md-8' onClick={() => (!sentence ? setSentence(checker.sentence) : null)}>
          <textarea
            rows={10}
            ref={inputRef}
            type='text'
            className='form-control'
            defaultValue={sentence || checker.sentence}
            onChange={(e) => setSentence(e.target.value)}
            style={{ textAlign: 'center' }}
            placeholder='Checker Sentence...'
          />
        </div>
      </div>

      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <b> {parseSentence(sentence || checker.sentence, condition, subCondition)}</b>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <button
          className='btn btn-outline-primary'
          onClick={() => {
            dispatch(
              apiAction({
                reduxField: 'condition',
                route: 'conditions/updateChecker',
                conditionId: condition._id,
                subConditionId: subCondition._id,
                checkerId: checker._id,
                updates: { sentence },
              })
            );
          }}
        >
          Save Sentence
        </button>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <a href={`/testchecker/${condition._id}/${subCondition._id}/${checker._id}`} target='_blank' rel='noreferrer'>
          Test Checker
        </a>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <h4>Supported Functions ({filteredFunctions.length})</h4>
      </div>
      {/* Supported Functions */}
      <div className='row d-flex justify-content-center mt-2 pt-lg-0'>
        <div className='col-md-8'>
          <TextField
            label='Search Functions'
            variant='outlined'
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <div className='col-md-8'>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Function Name</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Syntax</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredFunctions.map((func) => (
                  <TableRow key={func.name}>
                    <TableCell>{func.name}</TableCell>
                    <TableCell>{func.description}</TableCell>
                    <TableCell>{func.syntax}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
};

export default EditChecker;
